<template>
  <v-container>
    <v-row>
      <v-col>
        <v-select :items="sites" label="工地" v-model="site"></v-select>
        <v-btn
          depressed
          block
          color="blue-grey white--text"
          @click="searchRepair"
          >搜尋</v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="reportRepairs.length === 0" class="d-flex justify-center">
        目前工地無資料，請查別的工地
      </v-col>
      <v-col v-else>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">項目</th>
                <th class="text-left">數量</th>
              </tr>
            </thead>
            <tbody class="caption">
              <tr>
                <td>水電</td>
                <td>{{ stats.waterElectric }}</td>
              </tr>
              <tr>
                <td>防水</td>
                <td>{{ stats.waterProof }}</td>
              </tr>
              <tr>
                <td>衛浴設備</td>
                <td>{{ stats.bathroom }}</td>
              </tr>
              <tr>
                <td>弱電</td>
                <td>{{ stats.lowPower }}</td>
              </tr>
              <tr>
                <td>磁磚</td>
                <td>{{ stats.tiles }}</td>
              </tr>
              <tr>
                <td>廚具</td>
                <td>{{ stats.kitchen }}</td>
              </tr>
              <tr>
                <td>油漆</td>
                <td>{{ stats.paint }}</td>
              </tr>
              <tr>
                <td>木作</td>
                <td>{{ stats.wood }}</td>
              </tr>
              <tr>
                <td>其他</td>
                <td>{{ stats.others }}</td>
              </tr>
              <tr class="subtitle-2">
                <td>總共</td>
                <td>{{ reportRepairs.length }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { repairsCollection } from "@/db";

export default {
  name: "Report",
  data: () => ({
    sites: [
      "",
      "耀嵩豐",
      "悅嵩豐",
      "松丰",
      "文川",
      "淨美墅",
      "世璽",
      "帝門",
      "自由鑫貴",
      "綠園市2",
      "綠園市1",
      "品美術",
      "觀美術",
      "大社官邸",
      "嵩豐臻寶",
      "狀元邸",
      "嵩之園",
      "千禧園",
      "三荷園",
      "東方伯爵"
    ],
    reportRepairs: [],
    site: "",
    stats: {
      waterElectric: 0,
      waterProof: 0,
      bathroom: 0,
      lowPower: 0,
      tiles: 0,
      kitchen: 0,
      paint: 0,
      wood: 0,
      others: 0
    }
  }),
  methods: {
    searchRepair() {
      this.clearRepairs();
      var query = repairsCollection;
      query = query.where("site", "==", this.site);
      query
        .orderBy("created_at")
        .get()
        .then(querySnapshot => {
          querySnapshot.docs.forEach(element => {
            const repairData = {
              problemType: element.data().problemType
            };
            this.reportRepairs.push(repairData);
          });
        })
        .then(() => this.calculateData());
    },
    clearRepairs() {
      this.reportRepairs = [];
      this.stats = {
        waterElectric: 0,
        waterProof: 0,
        bathroom: 0,
        lowPower: 0,
        tiles: 0,
        kitchen: 0,
        paint: 0,
        wood: 0,
        others: 0
      };
    },
    calculateData() {
      this.reportRepairs.forEach(item => {
        if (item.problemType === "水電") {
          this.stats.waterElectric++;
        }
        if (item.problemType === "防水") {
          this.stats.waterProof++;
        }
        if (item.problemType === "衛浴設備") {
          this.stats.bathroom++;
        }
        if (item.problemType === "弱電") {
          this.stats.lowPower++;
        }
        if (item.problemType === "磁磚") {
          this.stats.tiles++;
        }
        if (item.problemType === "廚具") {
          this.stats.kitchen++;
        }
        if (item.problemType === "油漆") {
          this.stats.paint++;
        }
        if (item.problemType === "木作") {
          this.stats.wood++;
        }
        if (item.problemType === "其他") {
          this.stats.others++;
        }
      });
    }
  }
};
</script>
